import {defineStore} from 'pinia'
import {useMenuNavApi} from '@/api/sys/menu'
import {constantMenu, generateRoutes} from '@/router'
import {RouteRecordRaw} from 'vue-router'

export const routerStore = defineStore('routerStore', {
    state: () => ({
        menuRoutes: [] as RouteRecordRaw[],
        routes: [] as RouteRecordRaw[]
    }),
    actions: {
        async getMenuRoutes(id?: number) {
            const {data} = await useMenuNavApi()
            const routes = generateRoutes(data)

            if (id && id === 1) {
                // 常量菜单
                const constantRoutes = generateRoutes(constantMenu)
                this.menuRoutes.push(...constantRoutes)
            }

            this.menuRoutes.push(...routes)
            return this.menuRoutes
        },
        setRoutes(routers: RouteRecordRaw[]) {
            this.routes = routers
        }
    },
})
